export default "__VITE_ASSET__CAPZzKpA__"